var v1="<div class=\"form-group\"> <label for=\"{{ vm.settings.dataAt }}\">{{ vm.settings.displayName }}</label> <ui-select id=\"{{ vm.settings.dataAt }}\" name=\"{{ vm.settings.dataAt }}\" multiple=\"multiple\" ng-model=\"vm.data\"> <ui-select-match>{{ $item }}</ui-select-match> <ui-select-choices repeat=\"item in vm.items\"> <div ng-bind-html=\"item | highlight: $select.search\"></div> </ui-select-choices> </ui-select> <p class=\"help-block\" ng-if=\"vm.settings.helpText\">{{ vm.settings.helpText }}</p> </div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/lbaMultiSelect/lbaMultiSelect.html", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbaMultiSelect/lbaMultiSelect.html
// module id = 281
// module chunks = 0